import React from "react";
import styles from "./siteFooter.module.css";

export default function SiteFooter() {
  return (
    <div className={styles.siteFooter}>
      <div className={styles.webCredit}>
        Website by <a href="https://artfly.io/chris-dennett">ArtFly.io</a>
      </div>
      <div className={styles.mapCredit}>
        <span className={styles.mapCreditIntroText}>
          Maps: <a href="https://leafletjs.com/">Leaflet</a> |{" "}
        </span>
        © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>{" "}
        contributors
      </div>
    </div>
  );
}
